/** @format */

import {styled} from '@mui/material/styles';
import {Box} from '@mui/material';

const PREFIX = 'CheckboxRow';

const classes = {
  clickableArea: `${PREFIX}-clickableArea`,
  label: `${PREFIX}-label`,
  checkbox: `${PREFIX}-checkbox`,
  removeButton: `${PREFIX}-removeButton`,
  badge: `${PREFIX}-badge`,
  labelArea: `${PREFIX}-labelArea`,
};

const Root = styled(Box)(({theme}) => ({
  width: '100%',
  height: '48px',
  display: 'flex',
  alignItems: 'center',
  overflow: 'hidden',
  paddingRight: theme.spacing(4),
  userSelect: 'none',

  [`& .${classes.checkbox}`]: {
    height: '48px',
    width: '48px',
    flexShrink: 0,
    color: '#4A4B4F',

    '&.Mui-checked': {
      color: '#3E88C5',
    },
  },

  [`& .${classes.clickableArea}`]: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    transition: '0.2s',

    '&:hover': {
      background: '#f2f3f8',
    },
  },

  [`& .${classes.label}`]: {
    color: theme.palette.figma_gray_dark_5?.main,
    fontSize: '14px',
    lineHeight: '16px',
    userSelect: 'none',
    wordBreak: 'break-all',
  },

  [`& .${classes.removeButton}`]: {
    height: '48px',
    width: '48px',
    borderRadius: '0',

    '&:hover': {
      background: '#f2f3f8',
    },
  },

  [`& .${classes.labelArea}`]: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    color: theme.palette.figma_gray_dark_5?.main,
  },

  [`& .${classes.badge}`]: {
    width: '24px',
    height: '24px',
    borderRadius: '12px',
    backgroundColor: '#3E88C5',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    marginLeft: 'auto',
    marginRight: theme.spacing(2),
  },
}));

export {Root as CheckboxRowRoot, classes as checkboxRowClasses};
